import { render, staticRenderFns } from "./ConfiguratorFooter.vue?vue&type=template&id=581cb3be&scoped=true&lang=pug&"
import script from "./ConfiguratorFooter.vue?vue&type=script&lang=js&"
export * from "./ConfiguratorFooter.vue?vue&type=script&lang=js&"
import style0 from "./ConfiguratorFooter.vue?vue&type=style&index=0&id=581cb3be&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "581cb3be",
  null
  
)

export default component.exports